export const ROWS_PER_PAGE = 10;

export const step1Styles = {
  "@keyframes step1FadeUp": {
    from: { opacity: 0, transform: "translateY(6px)" },
    to: { opacity: 1, transform: "translateY(0)" },
  },
  "& .step1-left": {
    width: "clamp(350px, 35vw, 450px)",
    flexShrink: 0,
  },
  "& .step1-table-card": {
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    background: "#ffffff",
    overflow: "hidden",
  },
  "& .step1-table-header": {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 20px",
    background: "#9f9f9f"
  },
  "& .step1-badge": {
    background: "#e0f7fa",
    color: "#00bcd4",
    padding: "4px 12px",
    borderRadius: "16px",
    fontSize: "0.8rem",
    fontWeight: 700,
  },
  "& .step1-table-card .MuiTableCell-head": {
    color: "#ffffff",
    fontWeight: 700,
    fontSize: "0.75rem",
    padding: "12px 20px",
    background: "#9f9f9f",
    verticalAlign: "middle",
  },
  "& .step1-table-card .MuiTableCell-body": {
    padding: "14px 20px",
    borderBottom: "1px solid #f1f5f9",
    fontSize: "0.875rem",
    verticalAlign: "middle",
  },
  "& .step1-pager": {
    marginTop: "12px",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "8px",
  },
  "& .step1-right": {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    animation: "step1FadeUp 0.45s ease both",
  },
  "& .step1-right-card": {
    width: "100%",
    padding: "32px",
    border: "1px solid #e2e8f0",
    borderRadius: "16px",
    background: "#ffffff",
  },
  "& .step1-title": {
    color: "#1a202c",
    fontWeight: 700,
    fontSize: "clamp(1.5rem, 2.5vw, 1.75rem)",
    marginBottom: "16px",
  },
  "& .step1-subtitle": {
    color: "#718096",
    fontSize: "1rem",
    lineHeight: 1.6,
    marginBottom: "32px",
  },
  "& .step1-primary-actions": {
    display: "flex",
    gap: "16px",
    marginTop: "24px",
  },
  "& .step1-btn.MuiButton-root": {
    borderRadius: "8px",
    padding: ".5rem",
    fontWeight: 700,
    textTransform: "uppercase",
    transition: "all 0.2s ease",
  },
  "& .step1-btn-generate.MuiButton-root": {
    background: "#00bcd4",
    color: "#fff",
    flex: 1,
  },
  "& .step1-btn-generate.MuiButton-root:hover": {
    background: "#00a9b9",
  },
  "& .step1-btn-download.MuiButton-root": {
    border: "1px solid #e2e8f0",
    color: "#94a3b8",
    background: "#f8fafc",
    flex: 1,
  },
  "& .step1-btn-download.MuiButton-root:hover": {
    borderColor: "#00bcd4",
    background: "#f0fdff",
  },
  "& .step1-actions": {
    display: "flex",
    alignItems: "center",
    marginTop: "32px",
    width: "100%",
  },
  "@media (max-width:900px)": {
    "& .step1-left": {
      width: "100%",
    },
    "& .step1-primary-actions": {
      flexDirection: "column",
      gap: "12px",
    },
    "& .step1-right-card": {
      padding: "24px",
    },
    "& .step1-actions": {
      flexDirection: "column-reverse",
      gap: "12px",
    },
    "& .step1-btn.MuiButton-root": {
      width: "100%",
    },
  },
};
